import React from "react";
import { Modal, Table } from "antd";
import { ModalProps } from "antd/es/modal";
import useRequest from "../../../../../../utils/useRequest";
import {
    getIpAbnormalStudentInfoList,
    IpAbnormalStudentInfoListItem
} from "../../../../../../service/exam";
import { ColumnProps } from "antd/es/table";
import StuTableColumn from "../../../../../../components/CourseComponents/StuTableColumn";

interface IpChangeModalProps extends ModalProps {
    examId: number;
    studentNo: string;
}

export function IpChangeModal({
    examId,
    studentNo,
    ...props
}: IpChangeModalProps) {
    const [data, { loading }] = useRequest(
        () => getIpAbnormalStudentInfoList(examId, studentNo),
        {},
        [examId, studentNo]
    );

    const columns: ColumnProps<IpAbnormalStudentInfoListItem>[] = [
        {
            title: "考生信息",
            render: (_, item) => (
                <StuTableColumn
                    name={item.studentName}
                    stuNo={item.studentNo}
                />
            )
        },
        { title: "IP", dataIndex: "newIp" },
        { title: "时间", dataIndex: "time" },
        { title: "行为", dataIndex: "actionName" }
    ];

    return (
        <Modal title="IP异常监测" {...props} footer={false} width={1200}>
            <Table
                columns={columns}
                dataSource={data || []}
                loading={loading}
                pagination={false}
                scroll={{ y: 600 }}
            />
        </Modal>
    );
}
